import Component from 'vue-class-component';
import Vue from 'vue';
import moment from 'moment';
import { groupBy, flatMap } from 'lodash-es';

// Second based scheduler
@Component({
})
class Scheduler extends Vue {
  events = []
  now = null
  isInitialized = false
  watchStartedAt = null
  get eventsByDate () {
    return groupBy(this.events, 'date');
  }

  get eventsToTrigger () {
    const dates = Object.keys(this.eventsByDate).filter((date) =>
      moment(this.now).isAfter(moment(date)),
    );
    return flatMap(dates, (date) => this.eventsByDate[date]);
  }

  _onTick () {
    // console.log(this.eventsToTrigger, this.events, this.now)
    this.eventsToTrigger.forEach((ev) => {
      const index = this.events.findIndex(({ id }) => ev.id === id);
      this.events.splice(index, 1);
      ev.cb();
    });
    this.$emit('tick');
  }

  _registerEvent ({ id, date, cb = () => {} }) {
    this.events.push({ id, date, cb });
  }

  schedule (date, id, cb) {
    this._registerEvent({ id, date, cb });
  }

  tick (delta) {
    // console.log(delta, 'delta')
    this.now = moment(this.now).add(delta, 'ms').toISOString();
    this._onTick();
  }

  on (ev, cb) {
    this.$on(ev, cb);
  }

  once (ev, cb) {
    this.$once(ev, cb);
  }

  startStopwatch () {
    this.watchStartedAt = this.now;
    return this.now;
  }

  stopStopwatch () {
    const nowMoment = moment(this.now);
    const startTimeMoment = moment(this.watchStartedAt || this.now);
    const msSinceStart = nowMoment.diff(startTimeMoment);
    // console.log(msSinceStart, 'since start')
    return startTimeMoment.add(msSinceStart, 'ms').toISOString();
  }

  timeCorrection (value) {
    const nowMoment = moment(this.now);
    const nowCorrectedMoment = moment(value);
    const timeDiff = nowCorrectedMoment.diff(nowMoment);
    this.now = value;
    this.watchStartedAt = moment(this.watchStartedAt).add(timeDiff, 'ms').toISOString();
  }

  init (time) {
    this.now = moment(time).toISOString();
    this.$emit('init');
    this.isInitialized = true;
  }
};

const scheduler = new Scheduler();
export default scheduler;
